export const DirezioneConfig = {
  O: {
    fullName: 'Ovest - O',
    alphabet: 'O',
    number: 0,
  },
  E: {
    fullName: 'EST - E',
    alphabet: 'E',
    number: 1,
  },
  N: {
    fullName: 'Nord - N',
    alphabet: 'N',
    number: 2,
  },
  S: {
    fullName: 'Sud - S',
    alphabet: 'S',
    number: 3,
  },
  SC: {
    fullName: 'Singola carreggiata',
    alphabet: 'SC',
    number: 4,
  },
  EC: {
    fullName: 'Entrambe le carreggiate',
    alphabet: 'EC',
    number: 5,
  },
};
